/**
 * Frontend mirror of the backend's playground input limits. Keep in sync by convention -- the same
 * arrangement as pricingLimits.js mirroring the SubscriptionPlan enum.
 *
 * MAX_AUTH_TOKEN_LENGTH mirrors McpAuthTokenValidator.MAX_AUTH_TOKEN_LENGTH. The backend check is
 * the real gate (it returns a 400); this cap is UX only, so a paste that is obviously too long is
 * stopped at the input instead of after a round-trip.
 */
export const MAX_AUTH_TOKEN_LENGTH = 2048;
